import { useState } from 'react'
import useFetch from '../hooks/useFetch'
import useSnackbar from '../hooks/useSnackbar'
import { apiWrapper } from './dataHookUtils'

export default () => {
  const fetch = useFetch()
  const { newMessage } = useSnackbar()

  const [isLoading, setIsLoading] = useState(false)
  const [jobs, setJobs] = useState([])
  const [jobHistory, setJobHistory] = useState([])

  const getOptions = { method: 'GET' }
  const postHeaders = { "Content-Type": "application/json" }

  const postOptions = (data) => ({
    method: 'POST',
    headers: postHeaders,
    body: JSON.stringify(data)
  })

  const fetchMongoJobs = async () => {
    try {
      setIsLoading(true)
      const data = await apiWrapper({
        fetch,
        url: `mongoJobs`,
        options: getOptions
      });
      setJobs(data)
      return data
    } catch (e) {
      newMessage({ message: e?.message || 'Error getting Mongo jobs', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchCreateMongoJob = async (job) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `mongoJobs/create`,
        options: postOptions(job)
      });
    } catch (e) {
      newMessage({ message: e?.message || 'Error creating Mongo job', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchUpdateMongoJob = async (id, job) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `mongoJobs/${encodeURIComponent(id)}/update`,
        options: postOptions(job)
      });
    } catch (e) {
      newMessage({ message: e?.message || 'Error updating Mongo job', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchToggleMongoJob = async (id, enabled) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `mongoJobs/${encodeURIComponent(id)}/toggle`,
        options: postOptions({ enabled })
      });
    } catch (e) {
      newMessage({ message: e?.message || 'Error updating Mongo job status', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchDeleteMongoJob = async (id) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `mongoJobs/${encodeURIComponent(id)}/delete`,
        options: postOptions({})
      });
    } catch (e) {
      newMessage({ message: e?.message || 'Error deleting Mongo job', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchRunMongoJob = async (id) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `mongoJobs/${encodeURIComponent(id)}/run`,
        options: postOptions({})
      });
    } catch (e) {
      newMessage({ message: e?.message || 'Error running Mongo job', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchMongoJobHistory = async (id) => {
    try {
      setIsLoading(true)
      const data = await apiWrapper({
        fetch,
        url: `mongoJobs/${encodeURIComponent(id)}/history`,
        options: getOptions
      });
      setJobHistory(data)
      return data
    } catch (e) {
      newMessage({ message: e?.message || 'Error getting Mongo job history', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    jobs,
    jobHistory,
    fetchMongoJobs,
    fetchCreateMongoJob,
    fetchUpdateMongoJob,
    fetchToggleMongoJob,
    fetchDeleteMongoJob,
    fetchRunMongoJob,
    fetchMongoJobHistory
  }
}
